<template>
	<div id="purchaseOrders">
		<purchase-order-list-component></purchase-order-list-component>
	</div>
</template>

<script>
import mixin from '@/mixins'
import axiosAction from '@/mixins/axiosAction.js'
import errors from '@/mixins/errors.js'

import PurchaseOrderListComponent from '@/components/PurchaseOrderListComponent.vue'

export default {
	name: 'PurchaseOrders',
	mixins: [mixin, axiosAction, errors],
	data() {
		return {
		}
	},
	components: {
		'purchase-order-list-component': PurchaseOrderListComponent
	},
	computed: {
	},
	methods: {
		axiosResultLocal(responseLocal, response) {
			switch (responseLocal) {
				case 'defaultFunction': this.defaultFunction(response); break;
				default: console.log('Acción no determinada despues de la consulta (' + responseLocal + ')', this.$options.name); break;
			}
		},
		initModuleLocal() {
		}
	},
	mounted() {
		this.initModule(this.$options.name)
	},
}	
</script>

<style lang="scss"></style>
